import CompteDetailView from "@/pages/super-admin/components/CompteDetailView";

export default function SuperAdminProprietaireDetailPage() {
  return <CompteDetailView type="proprietaire" />;
}